import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MuralModel } from '../model/mural';
import { StorageService } from './storage.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
};  
const httpOptionsFile = {

  headers: new HttpHeaders({    
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
}; 

@Injectable({
  providedIn: 'root'
})
export class MuralService {

  constructor(private http:HttpClient,private storageService: StorageService) { }


  getDataMural(): Observable<any>{     
    return this.http.post<MuralModel>(environment.apiEndpoint + "mural/mural/" + this.storageService.getCurrentUser().idUsuario,null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }


  handleError(error) {    
    let errorMessage = '';
    errorMessage = `Error Code: ${error.status}\nMessage: ${error.error.message}`;
    return throwError(errorMessage);
}
}
